import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";

export interface AprendizNotInProgramaOption {
  id: number;
  nombre: string;
  correo: string;
}

export function useAprendicesNotInPrograma(
  idClienteFinal: number | undefined,
  idPrograma: number | undefined,
  search: string,
) {
  return useQuery<AprendizNotInProgramaOption[]>({
    queryKey: [
      "aprendices-not-in-programa",
      idClienteFinal,
      idPrograma,
      search,
    ],
    queryFn: async () => {
      const { data } = await axiosInstance.get("/aprendices/not-in-programa", {
        params: { idClienteFinal, idPrograma, search },
      });
      return data;
    },
    enabled: !!idClienteFinal && !!idPrograma,
    staleTime: 30 * 1000,
  });
}
